//Zoopla standard charts
//Zoopla 2020 - Data Visualization
//Designed and developed by Paulius Zutautas at Zoopla
//Index of rental demand from March to Mid-April 2020

import "./scss/app.scss";
import * as d3 from "d3";
import dataUrl from "./data/CitiesDemand_Mar20.csv";
// import highlighIcon from "./images/plusIcon.svg";
// import highlighIconHover from "./images/plusIconHover.svg";

const xValue = (d) => d.date;
const yValue = (d) => d.browsing_sales;
const startDate = new Date("2020-3-17");
const lockdownDate = new Date("2020-3-23");

import { labeledXAxis } from "./xAxisLabels.js";
import { labeledYAxis } from "./yAxisLabels.js";
import { mouseover, mouseout, mousemove } from "./mouseInteractionOne.js";
import {
  mouseoverTwo,
  mouseoutTwo,
  mousemoveTwo,
} from "./mouseInteractionTwo.js";

//Establishing a style object
const myThemeObject = {
  xAxisLabelFill: "#262630",
  yAxisLabelFill: "#262630",
  xAxisLabelOffset: 54,
  yAxisLabelOffset: 48,
  xAxisLabelFontSize: "11px",
  yAxisLabelFontSize: "11px",
  xAxisTickFontSize: "11px",
  yAxisTickFontSize: "11px",
  AxisTickFontFill: "#262630",
  AxisTickLineStroke: "#F1F1F7",
  AxisDomainLineStroke: "red",
  xAxisTickDensity: 54, //Pixel per tick
  yAxisTickDensity: 40, //Pixel per tick
};

//Render the visualisation at first
render();
//Render the visualisation on window resize
window.addEventListener("resize", render);

//The function of Render
function render() {
  //const barHeight = 44;
  //const heightFrame = 9 * (barHeight * 2);

  const chart = d3.select("#zoopla-bar-chart-horizontal");
  myResponsiveComponent(
    chart,
    Object.assign({}, myThemeObject, {
      width: document.getElementById("wrapper").clientWidth,
      height: 440,
      margin: { top: 28, bottom: 48, left: 74, right: 18 },
    })
  );
}

//The margin function with svg g element inside which is fired in main deatiled function below//
function marginComponents(selection, props) {
  const { width, height, margin } = props;
  let g = selection.selectAll(".marginGroup").data([null]);
  g = g
    .enter()
    .append("g")
    .attr("class", "marginGroup")
    .merge(g)
    .attr("transform", `translate(${margin.left}, ${margin.top})`);

  const innerWidth = width - margin.left - margin.right;
  const innerHeight = height - margin.top - margin.bottom;

  return { g, innerWidth, innerHeight };
}

//The entire detailed function of what happens while render is triggered//
function myResponsiveComponent(selection, props) {
  const { width, height, margin } = props;

  let svg = selection.selectAll("svg").data([null]);
  svg = svg
    .enter()
    .append("svg")
    .merge(svg)
    .attr("width", width)
    .attr("height", height);
  //Run margin function with objects aside
  const { g, text, innerWidth, innerHeight } = marginComponents(svg, {
    width,
    height,
    margin,
  });

  //parsing data START
  const data = d3.csv(dataUrl).then((data) => {
    data.forEach((d) => {
      d.demand_sales = +d.demand_sales;
      d.demand_19 = +d.demand_19;
      d.browsing_sales = +d.browsing_sales;
      d.date = new Date(d.date);
    });

    // data.forEach((d) => {
    //   const parseTime = d3.timeFormat("%m-%d");
    //   d.date = new Date(parseTime(d.date));
    // });

    // let sortedData = data.filter(function (d) {
    //   return d.date >= startDate;
    // });

    //Tick marks and Scales Responsive//

    //const colorValue = function(d) { return d.metric; };

    //console.log(sortedData);

    const dataPreLcokdown = data.filter((d) => {
      return d.date <= lockdownDate;
    });
    //console.log(dataPreLcokdown);
    const dataAfterLcokdown = data.filter((d) => {
      return d.date >= lockdownDate;
    });
    //console.log(dataAfterLcokdown);
    const xScale = d3
      .scaleTime()
      .domain(
        d3.extent(data, function (d) {
          return d.date;
        })
      )
      .range([0, innerWidth]);

    const yScale = d3
      .scaleLinear()
      .domain([0, d3.max(data, yValue)])
      .range([innerHeight, 0])
      .nice();

    //xScale.padding(0.2);

    labeledYAxis(g, Object.assign({}, props, { yScale, innerHeight })); //see function below for labels Y
    labeledXAxis(
      g,
      Object.assign({}, props, { xScale, innerHeight, innerWidth })
    ); //see function below for labels X

    let zeroLine = g.selectAll(".zeroLineS").data([null]);
    zeroLine = zeroLine
      .enter()
      .append("line")
      .attr("class", "zeroLineS")
      .merge(zeroLine)
      .attr("x1", 0) // x position of the first end of the line
      .attr("y1", yScale(100)) // y position of the first end of the line
      .attr("x2", innerWidth) // x position of the second end of the line
      .attr("y2", yScale(100));

    //const bisect = d3.bisector((d) => d.date);
    let verticalLineOne = g.selectAll(".verticalLineOneS").data([null]);
    verticalLineOne = verticalLineOne
      .enter()
      .append("line")
      .attr("class", "verticalLineOneS")
      .merge(verticalLineOne)
      .attr("x1", xScale(data[22].date)) // x position of the first end of the line
      .attr("y1", 0) // y position of the first end of the line
      .attr("x2", xScale(data[22].date)) // x position of the second end of the line
      .attr("y2", innerHeight);

    // var nested_data = d3.nest()
    // 	.key(colorValue)
    // 	.entries(data);

    //colorScale.domain(nested_data.map(d => d.key));

    const lineGeneratorAfter = d3
      .line()
      .x(function (d) {
        return xScale(d.date);
      })
      .y(function (d) {
        return yScale(d.browsing_sales);
      })
      .curve(d3.curveCatmullRom.alpha(1));

    let linePathAfter = g.selectAll(".linePathAfter").data([null]);
    linePathAfter = linePathAfter
      .enter()
      .append("path")
      .attr("class", "linePathAfter")
      .merge(linePathAfter)
      .attr("d", lineGeneratorAfter(data));

    // const lineGeneratorPre = d3
    //   .line()
    //   .x(function (d) {
    //     return xScale(d.date);
    //   })
    //   .y(function (d) {
    //     return yScale(d.browsing_sales);
    //   })
    //   .curve(d3.curveCatmullRom.alpha(1));

    // let linePathPre = g.selectAll(".linePathPre").data([null]);
    // linePathPre = linePathPre
    //   .enter()
    //   .append("path")
    //   .attr("class", "linePathPre")
    //   .merge(linePathPre)
    //   .attr("stroke-width", 1.5)
    //   .attr("stroke-linecap", "round")
    //   .attr("stroke", "#ff6009")
    //   .attr("fill", "none")
    //   .attr("d", lineGeneratorPre(dataPreLcokdown));

    //const yValue = function(d) {return d.value};
    //const xValue = function(d) {return d.year};

    // const circle = g.selectAll(".circleStyle").data(data); //for any data led object needs to be data instead [null]
    // circle
    //   .data(data)
    //   .enter()
    //   .append("circle") //data needs t omatch the above line [data]
    //   .attr("class", "circleStyle")
    //   .merge(circle)
    //   .attr("cy", function (d) {
    //     return yScale(yValue(d));
    //   })
    //   .attr("cx", function (d) {
    //     return xScale(xValue(d));
    //   })
    //   .on("mouseover", mouseover)
    //   .on("mousemove", mousemove)
    //   .on("mouseout", mouseout);

    function dd() {
      return (
        parseFloat(
          d3.select(".highlightIconOneS, .highlightIconTwoS").style("width")
        ) / 2
      );
    }
    function hh() {
      return (
        parseFloat(
          d3.select(".highlightIconOneS, .highlightIconTwoS").style("height")
        ) / 2
      );
    }

    // let highlightIconOne = g.selectAll(".highlightIconOneS").data([null]); //for any data led object needs to be data instead [null]
    // highlightIconOne = highlightIconOne
    //   .enter()
    //   .append("image") //data needs t omatch the above line [data]
    //   .attr("class", "highlightIconOneS")
    //   .merge(highlightIconOne)
    //   .attr("xlink:href", highlighIcon)
    //   .attr("width", "28px")
    //   .attr("height", "28px")
    //   .attr("y", function () {
    //     return yScale(data[22].demand) - dd();
    //   })
    //   .attr("x", function () {
    //     return xScale(data[22].date) - hh();
    //   })
    //   .on("mouseover", mouseover)
    //   .on("mousemove", mousemove)
    //   .on("mouseout", mouseout);

    let highlightIconTwo = g.selectAll(".circleStyle").data([null]); //for any data led object needs to be data instead [null]
    highlightIconTwo = highlightIconTwo
      .enter()
      .append("circle") //data needs t omatch the above line [data]
      .attr("class", "circleStyle")
      .merge(highlightIconTwo)
      //.attr("xlink:href", highlighIconHover)
      .attr("width", "28px")
      .attr("height", "28px")
      .attr("cy", function () {
        return yScale(data[22].browsing_sales);
      })
      .attr("cx", function () {
        return xScale(data[22].date);
      });
    // .on("mouseover", mouseoverTwo)
    // .on("mousemove", mousemoveTwo)
    // .on("mouseout", mouseoutTwo);

    // let legendOrande = g.selectAll(".legendOrange").data([null]);
    // legendOrande = legendOrande
    //   .enter()
    //   .append("rect")
    //   .attr("class", "legendOrange")
    //   .merge(legendOrande)
    //   .attr("transform", `translate(${innerWidth - 128},-4)`);

    let legend = g.selectAll(".legendOrange").data([null]);
    legend = legend
      .enter()
      .append("rect")
      .attr("class", "legendOrange")
      .merge(legend)
      .attr("transform", `translate(${innerWidth - 114},-4)`);

    let legendText = g.selectAll(".legendText").data([null]);
    legendText = legendText
      .enter()
      .append("text")
      .attr("class", "legendText")
      .merge(legendText)
      .text("Browsing sales")
      .attr("transform", `translate(${innerWidth},2)`);

    let highlightCircle = g.selectAll(".highlightCircleS").data([null]); //for any data led object needs to be data instead [null]
    highlightCircle = highlightCircle
      .enter()
      .append("circle") //data needs t omatch the above line [data]
      .attr("class", "highlightCircleS")
      .merge(highlightCircle)
      .attr("cy", function () {
        return yScale(data[data.length - 1].browsing_sales);
      })
      .attr("cx", function () {
        return xScale(data[data.length - 1].date);
      });

    let highlightText = g.selectAll(".highlightTextS").data([null]);
    highlightText = highlightText
      .enter()
      .append("text")
      .attr("class", "highlightTextS")
      .merge(highlightText)
      .html(
        `<tspan dx="-0.4em" dy="-3.6em">Browsing levels</tspan>
        <tspan dx="-6.9em" dy="1.4em">higher but 37%</tspan>
        <tspan dx="-8em" dy="1.4em">down on 1 March</tspan>`
      )
      .attr("y", function () {
        return yScale(data[data.length - 1].browsing_sales) - 12;
      })
      .attr("x", function () {
        return xScale(data[data.length - 1].date);
      });

    let lockdownHighlight = g.selectAll(".lockdownHighlightS").data([null]);
    lockdownHighlight = lockdownHighlight
      .enter()
      .append("text")
      .attr("class", "lockdownHighlightS")
      .merge(lockdownHighlight)
      .html(
        `<tspan dx="1.1em" dy="-4.2em">23 March</tspan>
        <tspan dx="-4.55em" dy="1.4em">Government</tspan>
        <tspan dx="-5.75em" dy="1.4em">announces</tspan>
        <tspan dx="-5em" dy="1.4em">lockdown</tspan>`
      )
      .attr("y", function () {
        return yScale(data[22].browsing_sales) + innerHeight / 2 - 18;
      })
      .attr("x", function () {
        return xScale(data[22].date);
      });

    d3.selectAll("svg").on("click", function () {
      // console.log("paspaudei belekur");
      d3.select("tooltip").style("visibility", "hidden");
    });
  });
  //parsing data FINISH
}
